import React, { useEffect, useState } from "react";

import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  creatingFaqBlock,
  resetUser,
} from "../../../../../redux/slices/block/createFaqBlockSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { toast } from "react-hot-toast";
import FAQForm from "../forms/FAQForm";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

const Faq = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { setActiveMainPageNav } = useStateContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { themeDirection } = useSettings();

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );

  // FAQ
  const faqCheck = blockFeature?.some(
    (item) => item.name === "faq" && paymenetBlocks === 1
  );
  useEffect(() => {
    if (!faqCheck) {
      navigate("/pricing");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // data needed for calling fetching list
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const usertoken = user.token;
  const linkId = localStorage.getItem("linkId");
  const linkListData = {
    userId,
    usertoken,
    linkId,
  };
  const [subLoader, setSubLoader] = useState(false);

  const handleHeadingTextSubmit = async (data) => {
    setSubLoader(true);

    await dispatch(creatingFaqBlock(data)).then(() => {});

    setSubLoader(false);
    fetchingLinksList(); // fetching link list after submiting , so list become refresh
  };

  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };

  const { faqBlockError, faqBlockSuccess, faqBlockLoading } = useSelector(
    (state) => state?.faqBlock
  );
  const { status, message } = useSelector((state) => state?.faqBlock?.faqBlock);

  useEffect(() => {
    if (status === "success" && faqBlockSuccess) {
      toast.success(message);
      navigate("/dashboard/component");
    }
    if (status === "failed" && faqBlockError) {
      toast.error(message);
    }
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [faqBlockError, faqBlockSuccess, dispatch, faqBlockLoading]);

  return (
    <>
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark"> {translate("faq")} </p>
          </div>
        </Link>
      </div>

      <FAQForm
        formType={"add"}
        submitHandlerParent={handleHeadingTextSubmit}
        isLoading={subLoader}
        // preHeaderData={preData}
      />
    </>
  );
};

export default Faq;
